import { TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import type { IFamilyGroup } from '../../models/family.interface';

@Component({
  selector: 'lib-becks-quick-family-filter',
  templateUrl: './becks-quick-family-filter.component.html',
  styleUrls: ['./becks-quick-family-filter.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButton, TitleCasePipe],
})
export class BecksQuickFamilyFilterComponent {
  @Input() familyGroups: IFamilyGroup[];
  @Input() selectedFamilyGroup: IFamilyGroup;

  @Output() onFamilyGroupSelected: EventEmitter<IFamilyGroup> = new EventEmitter();

  handleFamilyGroupSelected(selectedFamilyGroup: IFamilyGroup) {
    this.onFamilyGroupSelected.emit(selectedFamilyGroup);
  }
}
